angular.module('dentalLinks')
  .filter('fullAddress', function () {
    function normalize(value) {
      if (value === undefined || value === null) {
        return '';
      }
      return String(value).trim();
    }

    return function (address) {
      if (!address) {
        return '';
      }

      var parts = [];
      var streetLine1 = normalize(address.street_line_1 || address.streetLine1 || address.street);
      var streetLine2 = normalize(address.street_line_2 || address.streetLine2 || address.street2 || address.suite);
      var city = normalize(address.city);
      var state = normalize(address.state || address.province);
      var zip = normalize(address.zip || address.postal_code || address.postcode);

      var cityState = [city, state].filter(Boolean).join(', ');
      var cityStateZip = [cityState, zip].filter(Boolean).join(' ').trim();

      if (streetLine1) {
        parts.push(streetLine1);
      }
      if (streetLine2) {
        parts.push(streetLine2);
      }
      if (cityStateZip) {
        parts.push(cityStateZip);
      }

      return parts.join(', ');
    };
  });
